import { createTheme, ThemeOptions } from "@mui/material/styles";

export const theme: ThemeOptions = createTheme({
  palette: {
    primary: {
      main: "#1E2A8A",
      light: "rgba(30, 42, 138, 0.1)",
      dark: "#151C63",
    },
    secondary: {
      main: "#181F45",
      light: "rgb(247, 50, 30, 0.1)",
      dark: "rgb(247, 50, 30, 1)",
    },
    warning: {
      main: "#FF4F3D",
      light: "rgb(247, 50, 30, 0.1)",
      dark: "rgb(247, 50, 30, 1)",
    },
    info: {
      main: "#F2F2F2",
      light: "rgb(242, 242, 242, 0.1)",
      dark: "rgb(242, 242, 242, 1)",
    },
    background: {
      default: "#ffffff",
    },
    common: {
      black: "#000000",
      white: "#ffffff",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          fontFamily: "albertSans_regular",
          fontSize: "14px",
          borderRadius: "5px",
          height: "38px",
          padding: "0 50px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: "albertSans_light",
          color: "#2B2D22",
          "& fieldset": {
            borderRadius: "10px",
          },
          "& input::placeholder": {
            color: "#2B2D22",
            fontSize: "14px",
          },
          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
            {
              display: "none",
            },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          fontFamily: "albertSans_light",
          color: "#2B2D22",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "albertSans_light",
          color: "#2B2D22",
          opacity: "70%",
          fontSize: "14px",
        },
        shrink: ({ ownerState }) => ({
          ...(ownerState.shrink && {
            fontSize: "0.875rem !important",
            // top: "-1 !important",
          }),
        }),
      },
    },
    MuiInputBase: {
      styleOverrides: {
        formControl: {
          fontFamily: "albertSans_regular",
          color: "#2B2D22",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "albertSans_regular",
          color: "#2B2D22",
          fontSize: "14px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: "0px 2px 10px #0000001A",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 5px 20px #0000001A",
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: "0px 5px 20px #0000001A",
          borderRadius: "8px",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: "albertSans_regular",
          color: "#2B2D22",
          fontSize: "14px",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: "albertSans_medium",
          fontSize: "14px",
          color: "#2B2D22",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          fontFamily: "albertSans_regular",
          color: "#2B2D22",
        },
        option: {
          fontFamily: "albertSans_regular",
          color: "#2B2D22",
          fontSize: "14px",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#2B2D22",
        },
        h1: {
          color: "#2B2D22",
          fontFamily: "albertSans_semibold",
          fontSize: "32px",
        },
        h2: {
          color: "#2B2D22",
          fontFamily: "albertSans_semibold",
          fontSize: "28px",
        },
        h3: {
          color: "#2B2D22",
          fontFamily: "albertSans_semibold",
          fontSize: "24px",
        },
        h4: {
          color: "#2B2D22",
          fontFamily: "albertSans_medium",
          fontSize: "20px",
        },
        h5: {
          color: "#2B2D22",
          fontFamily: "albertSans_medium",
          fontSize: "16px",
        },
        h6: {
          color: "#2B2D22",
          fontFamily: "albertSans_medium",
          fontSize: "14px",
        },
        subtitle1: {
          color: "#2B2D22",
          fontFamily: "albertSans_regular",
          fontSize: "16px",
        },
        subtitle2: {
          color: "#2B2D22",
          fontFamily: "albertSans_regular",
          fontSize: "14px",
        },
        body1: {
          color: "#2B2D22",
          fontFamily: "albertSans_regular",
          fontSize: "14px",
          opacity: "95%",
        },
        body2: {
          color: "#2B2D22",
          fontFamily: "albertSans_regular",
          opacity: "85%",
          fontSize: "14px",
        },
        caption: {
          color: "#2B2D22",
          fontFamily: "albertSans_light",
          fontSize: "12px",
          opacity: "75%",
        },
      },
    },
  },
});
